customElements.component = 'brands-slider';

if (!customElements.get(customElements.component)) {
  class BrandsSlider extends HTMLElement {
    constructor() {
      super();

      this.sliderElement = this.querySelector('.js-brands-slider');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.showArrows === 'true';
      this.slidesPerViewDesktop = Number(this.dataset.slidesPerViewDesktop);
      this.loop = this.dataset.loop === 'true';
      this.draggable = this.dataset.draggable === 'true';

      this.arrowPrev = this.querySelector('.js-slide-prev');
      this.arrowNext = this.querySelector('.js-slide-next');
    }

    initializeSlider() {

      const params = {
        slidesPerView: 1,
        spaceBetween: 21,
        loop: this.loop,
        allowTouchMove: this.draggable,
        breakpoints: {
          768: {
            slidesPerView: this.slidesPerViewDesktop
          }
        }
      }

      if (this.showArrows) {
        params.navigation = {
          nextEl: this.arrowNext,
          prevEl: this.arrowPrev, 
        }
      }

      if (this.autoplay) {
        params.autoplay = {
          delay: this.autoplaySpeed,
          disableOnInteraction: false
        }
      }

      this.slider = new Swiper(this.sliderElement, params);
    }

    connectedCallback() {
      this.initializeSlider();
    }

    disconnectedCallback() {
      this.slider?.destroy(true, true);
    }
  }

  customElements.define(customElements.component, BrandsSlider);
}